import type { Theme } from "@mui/material";
import type { SystemStyleObject } from "@mui/system";

export const getReportsGridSx = (theme: Theme): SystemStyleObject<Theme> => ({
  ".MuiDataGrid-columnHeaders": {
    borderColor: theme.palette.divider,
    ".MuiDataGrid-columnHeader:nth-of-type(2)": {
      p: 0,
      outline: "none",
    },

    ".MuiDataGrid-columnHeader": {
      "&--sorted": {
        " .MuiDataGrid-iconButtonContainer": {
          visibility: "inherit",
        },
      },
      ".MuiCheckbox-root": {
        visibility: "hidden",

        "&.MuiCheckbox-indeterminate": {
          visibility: "visible",
        },
        "&.Mui-checked": {
          visibility: "visible",
        },
      },
      "&:focus": {
        outline: "none",
      },

      "&:hover": {
        ".MuiCheckbox-root": {
          visibility: "visible",
        },
      },
    },
  },

  ".MuiDataGrid-row": {
    ".favorite-star": {
      display: "none",
    },
    ".sharing-action": {
      visibility: "hidden",
    },
    ".MuiCheckbox-root": {
      visibility: "hidden",

      "&.MuiCheckbox-indeterminate": {
        visibility: "visible",
      },
      "&.Mui-checked": {
        visibility: "visible",
      },
    },
    "&:hover, &.Mui-hovered": {
      ".favorite-star": {
        display: "inline-flex",
      },
      ".sharing-action": {
        visibility: "visible",
      },
      ".MuiDataGrid-cell.grid-row-actions": {
        button: {
          visibility: "visible",
        },
      },
      ".highlighted-action": {
        color: theme.palette.primary.main,
      },
      ".MuiCheckbox-root": {
        visibility: "visible",
      },
    },
    "&.Mui-selected": {
      ".MuiCheckbox-root": {
        visibility: "visible",
      },
    },
    ".MuiDataGrid-cell": {
      outline: "none",
      borderBottomColor: theme.palette.divider,
    },
  },
  ".MuiDataGrid-cell": {
    "&.grid-row-actions": {
      button: {
        visibility: "hidden",
      },
    },
  },

  '[data-id^="auto-generated-row-"]': {
    '[data-field="__tree_data_group__"]': {
      px: 0,
    },

    ".MuiDataGrid-cellCheckbox": {
      maxWidth: "35px !important",
      minWidth: "35px !important",
    },
  },
  '.MuiDataGrid-row:not([data-id^="auto-generated-row-"])': {
    ".MuiDataGrid-cellCheckbox": {
      maxWidth: "35px !important",
      minWidth: "35px !important",
    },
    '[data-field="__tree_data_group__"]': {
      px: 0,
    },
    ".MuiDataGrid-cellCheckbox span": {
      visibility: "hidden",
    },
  },
});
